import { Autocomplete, FormControl, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";

// Header 

type Props = {
  pesquisa: string | null,
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  onClearFilters: () => void;
  handleCentroDeCusto: (v: number[]) => void;
  handlePesquisa: (v: string | null) => void,
};


export const Header = ({ centroDeCusto,  centroDeCustoLista, pesquisa ,handleCentroDeCusto ,onClearFilters, handlePesquisa}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-4 grid-cols-1 md:grid-cols-2">
          <FormControl size="small" fullWidth>
            <Autocomplete
              size="small"
              multiple
              options={centroDeCustoLista}
              value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
              getOptionLabel={(i) => i.title}
              onChange={(_, newValue) => {
                handleCentroDeCusto(newValue.map((i) => i.id));
              }}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Centro de custo" />
              )}
            />
          </FormControl>
          <div className="w-full">
            <DefaultInput
              label="Descrição"
              name="search_by_name"
              value={typeof pesquisa === 'string' ? pesquisa : ''}
              onChangeValue={handlePesquisa}
            />
          </div>

          <div className="w-full flex justify-end md:col-span-2 mt-2">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}